module.exports = __webpack_public_path__ + "img/setting.20da361f.svg";